export const FETCH_WORKSPACE_USERS_BY_IDS = 'fetchWorkspaceUsersByIds';
export const CREATE_USER = 'createUser';
export const UPDATE_USER_LOGIN_TIMESTAMP = 'updateUserLoginTimestamp';
export const UPDATE_USER_PROFILE = 'updateUserProfile';
export const FETCH_WORKSPACE_USERS = 'fetchWorkspaceUsers';
export const ARCHIVE_USER = 'archiveUser';
